<template>
  <div>
    <DateTimeInput :field="name" @datetime-event="addDateTimeValue" />
    <b-input-group class="justify-between">
      <label>{{ label }}</label>
      <VField v-slot="{ meta, errors }" v-model="form" :name="name" :rules="rules">
        <b-form-input
          :id="name"
          v-model="form"
          :name="name"
          :state="getValidationState(meta)"
          aria-describedby="input-1-live-feedback"
          type="number"
          :number="true"
          class="input-with-unit"
          :placeholder="placeholder"
          required
          @input="saveData"
        />
        <b-form-invalid-feedback id="input-1-live-feedback">{{
          errors[0]
        }}</b-form-invalid-feedback>
      </VField>
      <b-form-select
        id="crUnit"
        ref="crUnit"
        v-model="unit"
        text-field="text"
        value-field="value"
        class="unit-dropdown"
        :options="units"
        :clearable="false"
        required
        @change="saveData"
      >
      </b-form-select>
    </b-input-group>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import DateTimeInput from '@/components/inputs/DateTimeInput.vue';
import { displaySIUnits } from '@/models/utils/constants';
defineOptions({ name: 'InputDateValidation' });

const props = defineProps<{
  fieldDate: string | null;
  fieldName: string | null;
  fieldLabel?: string | null;
  fieldPlaceholder?: string;
  fieldForm: number | null;
  fieldUnit: string | null;
  unitList: string[];
  rulesList: Record<string, unknown> | null;
}>();

const emit = defineEmits<{
  (
    e: 'saveInputData',
    payload: { datetime: Date | null; value: number | null; unit: string | null },
  ): void;
}>();

const datetime = ref<Date | null>(props.fieldDate ? new Date(props.fieldDate) : null);
const name = props.fieldName;
const label = props.fieldLabel;
const placeholder = props.fieldPlaceholder ?? '';
const form = ref<number | null>(props.fieldForm);
const unit = ref<string | null>(props.fieldUnit);
const units = (props.unitList ?? []).map((u) => ({ value: u, text: displaySIUnits(u) }));
const rules = props.rulesList;

function saveData() {
  emit('saveInputData', { datetime: datetime.value, value: form.value, unit: unit.value });
}

function getValidationState(meta: { validated: boolean; valid: boolean }): boolean | null {
  return meta.validated ? meta.valid : null;
}

function addDateTimeValue(event: { field: string | null; value: Date }) {
  if (event.field === props.fieldName) {
    datetime.value = event.value;
    saveData();
  }
}
</script>

<style scoped></style>
